export enum ErrorEnum {
  Unauthorized = 401,
  SessionTimeout = 419,
  InternalServerError = 500,
}